import React from 'react';
import { AGE_BAND_LABEL } from '../../api/petAdapter';
import type { AgeBand } from '../../api/petAdapter';
import '../../styles/AgeBandFilter.css';

export type AgeBandValue = AgeBand | 'all';

interface AgeBandFilterProps {
  value: AgeBandValue;
  onChange: (next: AgeBandValue) => void;
}

const OPTIONS: { value: AgeBandValue; label: string }[] = [
  { value: 'all', label: 'Todas' },
  { value: 'filhote', label: AGE_BAND_LABEL.filhote },
  { value: 'jovem', label: AGE_BAND_LABEL.jovem },
  { value: 'adulto', label: AGE_BAND_LABEL.adulto },
  { value: 'senior', label: AGE_BAND_LABEL.senior },
];

const AgeBandFilter: React.FC<AgeBandFilterProps> = ({ value, onChange }) => (
  <fieldset className="age-band">
    <legend className="age-band__legend">Por idade</legend>
    <div className="age-band__pills" role="radiogroup" aria-label="Filtro por idade">
      {OPTIONS.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            className={`age-band__pill ${active ? 'is-active' : ''}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  </fieldset>
);

export default AgeBandFilter;
